<script lang="ts">
    import PageWrapper from '$lib/components/_page/PageWrapper.svelte';
    import Layout from '$lib/components/_page/Layout.svelte';

    // prettier-ignore
    let {
        children,
        data,
    } = $props()

    const {
        setup,
        loggedIn,
    } = data
</script>

<Layout
        setup={setup}
        awaitSetup={false}
        loggedIn={loggedIn.current}
>
    {#snippet page()}
        <PageWrapper pageMaxWidth={930}
                     footer={true}
        >
            {@render children()}
        </PageWrapper>
    {/snippet}
</Layout>
